import React from 'react'
import { string, number, shape, oneOfType, array } from 'prop-types'
import { getStoreSlug } from '@helpers/store-locator'
import Button from '@mui/material/Button'
import { ButtonLink } from '@templates/strapi-cms/content-types/Link'
import { useStaticQuery, graphql } from 'gatsby'

const StoreName = ({ mark: msStoreData }) => {
  const strapiStoreData = useStaticQuery(query)

  // Sync up strapi and microservice data to reconcile link url between PDP See in Store and Store Locator
  const strapiStore = strapiStoreData?.allStrapiStore?.edges?.find(
    e => e.node.StoreNumber === Number(msStoreData.StoreNumber),
  )?.node

  if (!strapiStore) {
    return (
      <span className="storeName" role="heading" aria-level="3">
        {msStoreData.name}
      </span>
    )
  }

  const storeUrl = getStoreSlug(strapiStore)

  return (
    <span className="storeName" role="heading" aria-level="3">
      <Button
        component={ButtonLink}
        data-testid={msStoreData.StoreNumber}
        data={{
          InternalUrl: storeUrl,
          title: msStoreData.name,
        }}
        trackingData={{ category: 'stores-locator', action: 'link to store detail page', label: storeUrl }}
      >
        {msStoreData.name}
      </Button>
    </span>
  )
}

StoreName.propTypes = {
  mark: shape({
    city: string,
    hours: oneOfType([shape({ regularHours: array }), array]),
    lat: number,
    lng: number,
    name: string,
    phoneNumber: string,
    state: string,
    StoreNumber: number,
    title: string,
    zip: string,
  }).isRequired,
}

export default StoreName

const query = graphql`
  query StoresQuery {
    allStrapiStore(filter: { strapi_id: { ne: 0 } }) {
      edges {
        node {
          id
          StoreNumber
          StoreName
          StoreType
          State
          City
          SpecialClosings {
            Markdown {
              Markdown {
                data {
                  childMarkdownRemark {
                    html
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
